import { Stack, Tooltip } from "@mui/material";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { OrderStatus } from "src/api/types";
import { capitalize } from "src/utils/capitalize";
import WarningIcon from "@mui/icons-material/Warning";

const colorMap: Record<
  OrderStatus,
  "error" | "default" | "primary" | "secondary" | "info" | "success" | "warning"
> = {
  canceled: "error",
  created: "default",
  delivered: "success",
  finalized: "info",
  paid: "success",
  sent_to_pharmacy: "success",
  shipped: "success",
  unpaid: "warning",
  denied: "error",
};

interface Props {
  status: OrderStatus;
  flag?: string;
}

const OrderStatusChip = ({ status, flag }: Props) => {
  return (
    <Stack direction="row" gap={1} justifyContent="center" alignItems="center">
      {flag != null ? (
        <Tooltip title={<Typography>{flag}</Typography>} placement="bottom">
          <WarningIcon color="error" />
        </Tooltip>
      ) : null}
      <Chip
        color={colorMap[status]}
        label={
          <Typography>{`${capitalize(status.split("_").join(" "))}`}</Typography>
        }
      />
    </Stack>
  );
};

export default OrderStatusChip;
